<script>
import DashboardLayout from '@/components/layouts/dashboard/DashboardLayout';
import TemplateForm from '@/components/templates/TemplateForm';
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'EditSite',
  components: {
    DashboardLayout,
    TemplateForm
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('Edit Template'),
      breadcrumbs: [],
      invalid: [],
      isDisabled: false,
      isSaving: false,
      statusCode: null,
      template: {}
    };
  },
  beforeRouteLeave(to, from, next) {
    // Check for unsaved changes
    if (this.$refs.templateForm.isDirty()) {
      this.$confirm(this.$t("Your changes haven't been saved. Are you sure you want to continue?"), {
        title: this.$t('Unsaved Changes'),
        confirmButtonText: this.$t('Continue'),
        cancelButtonText: this.$t('Cancel')
      }).then(() => next());
    } else {
      next();
    }
  },
  created() {
    // Fetch initial data
    Promise.all([
      this.$http.get(`/sites/${this.$route.params.siteId}`),
      this.$http.get(`/sites/${this.$route.params.siteId}/templates/${this.$route.params.templateId}`)
    ])
      .then(res => {
        this.site = res[0].data.site;
        this.template = res[1].data.template;
        this.breadcrumbs = [
          { text: this.$t('Sites'), to: { name: 'Sites' } },
          { text: this.site.name, to: { name: 'Site', params: { siteId: this.site.id } } },
          { text: this.$t('Manage Templates'), to: { name: 'Templates', params: { siteId: this.site.id } } },
          { text: this.$t('Edit Template') }
        ];
        this.statusCode = 200;

        this.$nextTick(() => {
          this.$refs.templateForm.setData(this.template);
          this.$refs.templateForm.resetCleanState();
        });
      })
      .catch(err => (this.statusCode = err.response.status));
  },
  methods: {
    // Cancels all changes and goes back to the sites page
    handleCancel() {
      this.$router.push({ name: 'Templates', params: { siteId: this.site.id } });
    },

    // Saves the site
    handleSave() {
      const data = this.$refs.templateForm.getData();
      this.isSaving = true;
      this.$http
        .put(`/sites/${this.site.id}/templates/${this.template.id}`, data)
        .then(() => {
          this.invalid = [];
          this.$refs.templateForm.resetCleanState();
          this.$router.push({ name: 'Templates', params: { siteId: this.site.id } });
        })
        .catch(err => {
          const data = err.response.data;
          this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
          this.$notify({
            type: 'error',
            title: this.$t('Error'),
            message: getErrorMessage(err.response.data.code)
          });
        })
        .finally(() => (this.isSaving = false));
    }
  }
};
</script>

<template>
  <dashboard-layout :status-code="statusCode" size="small">
    <!-- Breadcrumbs -->
    <template slot="breadcrumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index" :to="item.to">
          {{ item.text }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <!-- Template form -->
    <template-form
      ref="templateForm"
      :disabled="isDisabled"
      :invalid="invalid"
      :saving="isSaving"
      @cancel="handleCancel"
      @submit="handleSave"
    />
  </dashboard-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

// No styles yet
</style>
